import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"
import { LoaderCircleIcon } from "lucide-react"

const loadingVariants = cva(
  "",
  {
    variants: {
      variant: {
        default:
          "",
        centered:
          "w-full h-full flex justify-center items-center",
        item:
          "flex items-center justify-center rounded-md w-full border shadow-none bg-background min-h-10",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface LoadingProps
  extends React.ButtonHTMLAttributes<HTMLDivElement>,
  VariantProps<typeof loadingVariants> {
  iconClassName?: string;
}

const Loading = React.forwardRef<HTMLDivElement, LoadingProps>(
  ({ className, variant, children, iconClassName }, ref) => {
    return (
      <div ref={ref} className={cn(loadingVariants({ variant, className }))}      >
        {children || (<LoaderCircleIcon className={cn("text-foreground size-4 animate-spin duration-2000", { "size-6": variant === "centered" }, iconClassName)} />)}
      </div>
    )
  }
)
Loading.displayName = "Loading"

export { Loading, loadingVariants }
